module.exports = __webpack_public_path__ + "static/media/Glynn,Amy.a6560c44.png";